var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe 433",
    clipPath: "url(#clip0_402_614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe 433_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M5.50859 9.24001C5.64576 9.35267 5.8191 9.41182 5.99653 9.40649C6.17396 9.40115 6.34344 9.33171 6.47359 9.21101C6.85823 8.8649 7.35618 8.67141 7.87359 8.66701C8.38929 8.66792 8.887 8.85669 9.27359 9.19801C9.40485 9.31743 9.57493 9.38525 9.75234 9.38893C9.92976 9.39261 10.1025 9.33189 10.2386 9.21801C10.336 9.13289 10.4145 9.02829 10.4691 8.91096C10.5236 8.79364 10.553 8.66619 10.5552 8.53683C10.5575 8.40747 10.5326 8.27907 10.4822 8.15991C10.4318 8.04075 10.357 7.93348 10.2626 7.84501C9.6029 7.25384 8.74841 6.92664 7.86259 6.92601C6.9765 6.93491 6.12481 7.27031 5.47059 7.868C5.37707 7.95735 5.30333 8.06532 5.25412 8.18494C5.20492 8.30455 5.18134 8.43316 5.18492 8.56245C5.18851 8.69174 5.21916 8.81884 5.27491 8.93555C5.33066 9.05225 5.41027 9.15597 5.50859 9.24001Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path853",
    d: "M2.93223 7.289C3.0078 7.35059 3.0948 7.39662 3.18823 7.42444C3.28167 7.45226 3.37968 7.46132 3.47663 7.4511C3.57357 7.44087 3.66754 7.41157 3.75312 7.36487C3.83869 7.31817 3.91418 7.255 3.97523 7.179C4.45217 6.60882 5.04648 6.14821 5.71763 5.8286C6.38877 5.50899 7.12095 5.3379 7.86423 5.327C8.60777 5.33082 9.34173 5.49504 10.016 5.80844C10.6903 6.12185 11.289 6.57707 11.7712 7.14301C11.833 7.21841 11.9091 7.28085 11.9951 7.32672C12.0811 7.3726 12.1754 7.401 12.2724 7.41029C12.3695 7.41959 12.4674 7.4096 12.5605 7.38089C12.6537 7.35218 12.7403 7.30531 12.8152 7.243C12.9978 7.08158 13.1098 6.85504 13.1271 6.61198C13.1445 6.36893 13.0659 6.12875 12.9082 5.94299C12.2853 5.20986 11.5112 4.62004 10.6391 4.21391C9.76691 3.80779 8.81729 3.59495 7.85523 3.59C6.89341 3.60404 5.94598 3.82577 5.07781 4.24001C4.20964 4.65424 3.44125 5.2512 2.82523 5.99001C2.66951 6.17745 2.59349 6.41848 2.6135 6.66135C2.6335 6.90422 2.74794 7.12956 2.93223 7.289Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path857",
    d: "M0.681533 5.416C0.754304 5.47917 0.839551 5.52634 0.931736 5.55441C1.02392 5.58249 1.12098 5.59086 1.21661 5.57898C1.31224 5.5671 1.4043 5.53523 1.48681 5.48544C1.56932 5.43566 1.64044 5.36907 1.69553 5.29001C2.40076 4.30735 3.32467 3.502 4.39437 2.93747C5.46408 2.37294 6.65032 2.06468 7.85953 2.037C9.06808 2.05233 10.2565 2.3483 11.3311 2.90155C12.4057 3.45481 13.337 4.25021 14.0515 5.22501C14.1073 5.30378 14.1791 5.3699 14.2621 5.41904C14.3452 5.46818 14.4377 5.49923 14.5336 5.51018C14.6295 5.52113 14.7266 5.51173 14.8186 5.48257C14.9106 5.45342 14.9954 5.40518 15.0675 5.341C15.2401 5.18017 15.3472 4.96126 15.3682 4.72632C15.3892 4.49137 15.3228 4.25695 15.1815 4.06801C14.3354 2.91449 13.2328 1.97333 11.9608 1.31874C10.6887 0.664152 9.282 0.314037 7.85153 0.296005C6.42017 0.327662 5.01572 0.691371 3.74891 1.35844C2.48209 2.02552 1.38754 2.97772 0.551534 4.14C0.411404 4.33105 0.347127 4.5673 0.371141 4.80301C0.395156 5.03872 0.505754 5.25714 0.681533 5.416Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path861",
    d: "M7.87362 12.441C7.61264 12.4402 7.36262 12.336 7.17836 12.1512C6.99409 11.9663 6.89062 11.716 6.89063 11.455C6.89062 11.194 6.99409 10.9437 7.17836 10.7589C7.36262 10.574 7.61264 10.4698 7.87362 10.469C8.13461 10.4698 8.38463 10.574 8.56889 10.7589C8.75316 10.9437 8.85663 11.194 8.85662 11.455C8.85663 11.716 8.75316 11.9663 8.56889 12.1512C8.38463 12.336 8.13461 12.4402 7.87362 12.441Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.745,
    height: 12.741,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.272fcb06ec21526cfe59397d41ee9cc8.svg";
export { ForwardRef as ReactComponent };